var confirmBulkOperationAjaxValue = null;

$(function () {
  var moreNum = Number($('#illi-review-view-counts').val());

  
  $('.illi-review-moreread').on('click', function () {
    $('.illi-review-review.is-hidden').slice(0, moreNum).removeClass('is-hidden');
    if ($('.illi-review-review.is-hidden').length == 0) {
      $('.illi-review-moreread').fadeOut();
    }
  });

  
  $(function () {
    var list = $(".illi-review-reviews div").length;
    if (list <= moreNum) {
      $('.illi-review-moreread').addClass('is-btn-hidden');
    }
  });

  $('.illi-review-write-review-button').on('click', function () {
    $('.illi-review-input.is-hidden').removeClass('is-hidden');
  });

  $('.illi-review-post-review-button').on('click', function () {
    const reviewScore = $('input[name=reviewScore]:checked').val(); 
    const reviewTitle = $('#illi-review-input-title-text').val(); 
    const reviewDescription = $('#illi-review-input-description-text').val(); 

    
    var validation = true;
    if (reviewTitle == "") {
      validation = false;
      $('#illi-review-error-message-title').text("レビュータイトルが入力されていません");
      $('#illi-review-error-message-title').removeClass('is-hidden');
    } else {
      $('#illi-review-error-message-title').text("");
      $('#illi-review-error-message-title').addClass('is-hidden');
    }
    if (reviewDescription == "") {
      validation = false;
      $('#illi-review-error-message-description').text("レビュー内容が入力されていません");
      $('#illi-review-error-message-description').removeClass('is-hidden');
    } else {
      $('#illi-review-error-message-description').text("");
      $('#illi-review-error-message-description').addClass('is-hidden');
    }
    if (validation == false) {
      return;
    }

    var dialog = document.getElementById("illi-review-dialog");
    dialog.showModal();
  });

  $('#illi-review-dialog').on('close', function () {
    if (this.returnValue === 'yes') {
      const customerId = $('#illi-review-customer-id').val(); 
      const productId = $('#illi-review-product-id').val(); 
      const reviewScore = $('input[name=reviewScore]:checked').val(); 
      const reviewTitle = $('#illi-review-input-title-text').val(); 
      const reviewDescription = $('#illi-review-input-description-text').val(); 
      const appStatus = $('#illi-review-app-status').val(); 

      
      let targetElements = document.getElementsByClassName("illi-review-post-review-button");
      screenLock(targetElements[0]);
      postReview(customerId, productId, reviewScore, reviewTitle, reviewDescription, appStatus)
    }
  });
});



function postReview(customerId, productsId, reviewScore, reviewTitle, reviewDescription, appStatus) {
  $.when(
    $.ajax({
      url: '/apps/review-apps/accept', 
      
      type: 'POST',
      dataType: 'json',
      data: {
        customerId: customerId,
        productsId: productsId,
        reviewScore: reviewScore,
        reviewTitle: reviewTitle,
        reviewDescription: reviewDescription,
      },
      timeout: 30000,

    }).then(
      function (res) { 
        if (res.status == 'success') {
          
          if (appStatus == "free") {
            $('#illi-review-message-dialog-content').text("レビュー投稿ありがとうございます。反映までしばらくお待ちください。");
          } else {
            $('#illi-review-message-dialog-content').text("レビュー投稿を受け付けました。当店による承認後反映させていただきます。");
          }
          $('#illi-review-error-message-post').text("");
          $('#illi-review-error-message-post').addClass('is-hidden');
          var dialog = document.getElementById("illi-review-message-dialog");
          dialog.showModal();
          screenUnlock();

        } else if (res.status == 'success-mustBuy') {
          const bulkOperationId = res.result["bulkOperationId"];

          var firstResult = "";
          firstResult = confirmBulkOperation(customerId, productsId, reviewScore, reviewTitle, reviewDescription, bulkOperationId, appStatus);
          if (firstResult == 'running') {
            confirmBulkOperationAjaxValue = setInterval(confirmBulkOperation, 10000, customerId, productsId, reviewScore, reviewTitle, reviewDescription, bulkOperationId, appStatus);
          }

        } else {
          
          $('#illi-review-error-message-post').text(res.result);
          $('#illi-review-error-message-post').removeClass('is-hidden');
          screenUnlock();
        }
      },
      function () {
        
        $('#illi-review-error-message-post').text("no connection.");
        $('#illi-review-error-message-post').removeClass('is-hidden');
        screenUnlock();
      }
    )
  ).done(function () {
  }
  );


}


function confirmBulkOperation(customerId, productsId, reviewScore, reviewTitle, reviewDescription, bulkOperationId, appStatus) {
  var retValue = "done"

  $.when(
    $.ajax({
      url: '/apps/review-apps/confirm-bulk-operation', 
      type: 'POST',
      dataType: 'json',
      async: false,
      data: {
        customerId: customerId,
        productsId: productsId,
        reviewScore: reviewScore,
        reviewTitle: reviewTitle,
        reviewDescription: reviewDescription,
        bulkOperationId: bulkOperationId,
      },
      timeout: 30000,

    }).then(
      function (res) { 
        if (res.status == 'success') {
          
          if (confirmBulkOperationAjaxValue !== null) {
            clearTimeout(confirmBulkOperationAjaxValue);
          }
          if (appStatus == "free") {
            $('#illi-review-message-dialog-content').text("レビュー投稿ありがとうございます。反映までしばらくお待ちください。");
          } else {
            $('#illi-review-message-dialog-content').text("レビュー投稿を受け付けました。当店による承認後反映させていただきます。");
          }
          $('#illi-review-error-message-post').text("");
          $('#illi-review-error-message-post').addClass('is-hidden');
          var dialog = document.getElementById("illi-review-message-dialog");
          dialog.showModal();
          screenUnlock();

        } else if (res.status == 'running') {
          retValue = 'running';
          return
        } else {
          
          if (confirmBulkOperationAjaxValue !== null) {
            clearTimeout(confirmBulkOperationAjaxValue);
          }
          $('#illi-review-error-message-post').text(res.result);
          $('#illi-review-error-message-post').removeClass('is-hidden');
          screenUnlock();
        }
      },
      function () {
        
        if (confirmBulkOperationAjaxValue !== null) {
          clearTimeout(confirmBulkOperationAjaxValue);
        }
        $('#illi-review-error-message-post').text("no connection.");
        $('#illi-review-error-message-post').removeClass('is-hidden');
        screenUnlock();
      }
    )
  ).done(function () {
  }
  );
  return retValue
}
